import { toast } from "sonner";
import { Copy } from "lucide-react";
import { useSite } from "@/lib/site";

const TAGS = "#cirencester4x4 #webuy4x4 #sellmycar #sellyourcar #4x4 #suv #landrover #rangerover #defender #cotswolds #gloucestershire #usedcars";

const captions = (phone) => [
  ["ad-1", "Ad 1 caption: \"Actively looking for quality 4x4s\"", [
    "We're buying 🌿",
    "We're actively looking for quality 4x4s to join our carefully selected stock.",
    "✔️ Up to two owners\n✔️ Full service history\n✔️ No MOT failures",
    "🚚 Collection anywhere\n🤝 Sale or return considered",
    `Thinking of selling? Send us a DM, WhatsApp ${phone} or tap the link in bio for a no-obligation valuation.`,
    "📍 Cirencester, the Cotswolds",
    TAGS,
  ]],
  ["ad-2", "Ad 2 caption: \"Wanted: quality 4x4s\"", [
    "Wanted: quality 4x4s ✨",
    "Does your 4x4 tick every box? If it has had no more than two owners, a full service history and has never failed an MOT, we'd love to hear from you.",
    "We collect from anywhere, and sale or return is considered.",
    `📩 Send us a DM or WhatsApp ${phone} with the registration and mileage, or tap the link in bio to request your valuation.`,
    "Carefully selected. Properly prepared.\n📍 Cirencester, the Cotswolds",
    TAGS,
  ]],
];

export function BuyingAdCaptions() {
  const { phone } = useSite();
  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Caption copied");
    } catch {
      toast.error("Could not copy. Please allow clipboard access and try again.");
    }
  };
  return (
    <div className="mt-6 grid gap-5 lg:grid-cols-2" data-testid="buying-ad-captions">
      {captions(phone).map(([id, label, parts]) => {
        const text = parts.join("\n\n");
        return (
          <div key={id} className="border border-stone p-4" data-testid={`caption-card-${id}`}>
            <div className="flex items-center justify-between gap-3">
              <p className="text-sm font-semibold">{label}</p>
              <button onClick={() => copy(text)} className="flex items-center gap-2 border border-forest px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-forest hover:bg-forest hover:text-paper" data-testid={`copy-ad-caption-${id}`}><Copy className="h-3.5 w-3.5" /> Copy</button>
            </div>
            <pre className="mt-3 max-h-56 overflow-auto whitespace-pre-wrap font-sans text-xs leading-relaxed text-charcoal/80">{text}</pre>
          </div>
        );
      })}
      <p className="text-xs text-charcoal/70 lg:col-span-2">Tip: set your Instagram link in bio to your website's /we-are-buying page so the adverts lead straight to the valuation form. Stories don't have captions, so use the Feed versions with these.</p>
    </div>
  );
}
